import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../_services/api.service';

@Injectable({ providedIn: 'root' })
export class InstallatoriResolver implements Resolve<any> {

  constructor(
    private api: ApiService,
    private localize: LocalizeRouterService
    ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return this.api.searchFornitori({cdLingua: this.localize.parser.currentLang.toUpperCase()}).pipe(map(res => res.responses));
  }
}
